import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@material-ui/data-grid';
import { Container, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';

import { GridArea, BirthDayTitle,Birthday } from './style';
import { FormatDay, GetMonthName } from '../../Utils';
import { getBirthdays } from '../../actions/Auth';
import TableHeader from '../common/TableHeader';
import { ModalAction } from '../common/Modal';
import { Noresults } from '../../Layout/style';

const BirthDay = () => {
  const dispatch = useDispatch();
  const { birthDays, allBirthDays } = useSelector(({ auth }) => ({
    birthDays: auth?.birthDays || [],
    allBirthDays: auth?.allBirthDays || [],
  }));

  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  const [searchStringAll, setSearchStringAll] = useState('');
  const [filteredElementsAll, setFilteredElementsAll] = useState('');
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(0);
  const [page2, setPage2] = useState(0);

  useEffect(() => {
    if (!birthDays?.length) dispatch(getBirthdays());
  }, []);

  useEffect(() => {
    const cleanValue = searchString.replace(/[-[/\]{}()*+?.,\\^$|#]/g, '');
    const searchRegex = new RegExp(`${cleanValue}`, 'gi');
    const searchedItens = birthDays.filter((i) => i.name.match(searchRegex) || i.ut.match(searchRegex) || i.office.match(searchRegex));
  
    if (page > 0) {
      setPage(0)
    }

    if (!searchString) setFilteredElements(birthDays);
    else setFilteredElements(searchedItens);
  }, [searchString]);

  useEffect(() => {
    if (page2 > 0) {
      setPage2(0)
    }
    const cleanValue = searchStringAll.replace(/[-[/\]{}()*+?.,\\^$|#]/g, '');
    const searchRegex = new RegExp(`${cleanValue}`, 'gi');
    const searchedItens = allBirthDays.filter((i) => i.name.match(searchRegex) || i.ut.match(searchRegex) || i.office.match(searchRegex));

    if (!searchStringAll) setFilteredElementsAll(allBirthDays);

    else setFilteredElementsAll(searchedItens);
  }, [searchStringAll]);

  const date = new Date();
  const columns = [
    { field: 'name', width: 310, headerName: 'Nome' },
    { field: 'ut', width: 300, headerName: 'UT' },
    { field: 'office', width: 300, headerName: 'Cargo/Atividade' },
    {
      field: 'birthDay',
      width: 300,
      headerName: 'Aniversário',
      sortable: false,
    },
  ];

  return (
    <Container>
      <BirthDayTitle>
        <Birthday>
        <FontAwesomeIcon size="xs" style={{
          fontSize:165
        }}  icon={faBirthdayCake} />
        <Typography variant="h5" style={{
            marginLeft:20
        }}>
          {GetMonthName(date.getMonth())}
          <br /> <b>{FormatDay(date.getDate())}</b>
        </Typography>
        </Birthday>
        <Typography
        align='center'
        style={{
          color:'#000',
          fontFamily:'IBMPlexSans-SemiBold'
        }} variant="h5">
        Feliz <br />
          <Typography style={{
          fontFamily:'IBMPlexSans-SemiBold'
        }} variant="h1">
          Aniversário!
          </Typography>
        </Typography>
      </BirthDayTitle>
      <TableHeader
        btnLabel="Todos Aniversários"
        btnAction={() => setModal(true)}
        setSearchString={setSearchString}
        placeholder="Pesquisar aniversariante do dia por Nome, UT ou Cargo/Atividade"
      />
      <GridArea style={{ height: 500, width: '100%', background: 'white' }}>
        <DataGrid
          components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
          page={page}
          onPageChange={(newPage) => setPage(newPage.page)}
          pageSize={10}
          disableSelectionOnClick
          disableColumnMenu
          hideFooterSelectedRowCount
          rows={filteredElements?.length ? filteredElements : []}
          columns={columns}
        />
      </GridArea>
      <ModalAction title={'Todos Aniversários'} open={modal} backAction={() => setModal(false)}>
        <GridArea style={{ height: 500, width: '100%', background: 'white' }}>
          <TableHeader
            setSearchString={setSearchStringAll}
            placeholder="Pesquisar por Nome, Ut ou Cargo/Atividade"
          />
          <DataGrid
            components={{
              NoRowsOverlay: () => (
                <Noresults>
                  <span>
                    Resultados não encontrado
                  </span>
                </Noresults>
              ),
            }}
            page={page2}
            onPageChange={(newPage) => setPage2(newPage.page)}
            pageSize={7}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElementsAll?.length ? filteredElementsAll : []}
            columns={columns}
          />
        </GridArea>
      </ModalAction>
    </Container>
  );
};

export default BirthDay;
